module.exports = __webpack_public_path__ + "static/media/CAMARONEGG_MENU-normal.5431699e.png";